import * as fileSvc from 'services/files.service';
import { GET_ROOT_FOLDER } from './types';

export const getRootFolder = (query) => ({
  type: GET_ROOT_FOLDER,
  payload: {
    promise: fileSvc.listFolders(query).then(r => r[0])
  }
});

